import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CATEGORY_EDIT, SPA_CATEGORY_TAB_LIST } from '../../../../../constants/SpaConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_SPA,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allSpaCategoriesSelector,
  allSpaInfoSelector,
  allSpaTreatmentsSelector,
} from '../../../../property/propertySlice';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const CategoryView = (props) => {
  const { category, onViewToggle, toggleDrawer, selectedHotel, permissions } = props;
  const [selectedCategory, setSelectedCategory] = useState(category);
  const originalSpaInfo = useSelector(allSpaInfoSelector);
  const [tabValue, setTabValue] = useState(0);
  const originalSpaCategory = useSelector(allSpaCategoriesSelector);
  const originalSpaTreatments = useSelector(allSpaTreatmentsSelector);

  useEffect(() => {
    const catObj = {
      ...originalSpaCategory.find((cat) => cat.id === category.id),
    };
    catObj['spa'] = originalSpaInfo.filter((spaItem) => spaItem.id === catObj.spaId);
    catObj['treatments'] = originalSpaTreatments.filter(
      (treatment) => treatment.spaCategoryId === catObj.id,
    );
    setSelectedCategory(catObj);
  }, [selectedHotel, originalSpaCategory]);

  const onClickEdit = (event) => {
    toggleDrawer(CATEGORY_EDIT, true, selectedCategory);
  };

  const getTreatments = (treatments) => {
    return treatments
      .map((tempTreatment) => {
        return tempTreatment.name;
      })
      .join(', ');
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <>
        <div className='mx-4'>
          {tabValue === 0 && (
            <>
              <div className='row mt-4 mb-2'>
                <div className='col-md-12 mb-4'>
                  <span className='page-title-secondary'>Details</span>
                </div>
              </div>
              <div className='row mt-4 mb-2'>
                <div className='col-md-6'>
                  <div className='details-label'>Category Name</div>
                  <div className='details-value preview-breaks'>{selectedCategory?.name}</div>
                </div>
                <div className='col-md-6'>
                  <div className='details-label'>Category Code</div>
                  <div className='details-value'>{selectedCategory?.code}</div>
                </div>
              </div>
              <div className='row mt-4 mb-2'>
                <div className='col-md-6'>
                  <div className='details-label'>Spa Name</div>
                  <div className='details-value'>
                    {selectedCategory?.spa?.length ? selectedCategory?.spa[0]?.name : '---'}
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='details-label'>No of treatments</div>
                  <div className='details-value'>{selectedCategory?.treatments?.length}</div>
                </div>
              </div>
              <div className='row mt-4 mb-2'>
                <div className='col-md-12'>
                  <div className='details-label'>Treatments</div>
                  <div className='details-value'>
                    {selectedCategory?.treatments?.length
                      ? getTreatments(selectedCategory?.treatments)
                      : '---'}
                  </div>
                </div>
              </div>
              <div className='row mt-4'>
                {selectedCategory?.customAttributes &&
                  selectedCategory?.customAttributes?.length > 0 &&
                  selectedCategory?.customAttributes?.map((item, index) => (
                    <div key={index} className='col-md-6 mb-2'>
                      <div className='details-label'>{item?.key}</div>
                      <div className='details-value'>{item?.value}</div>
                    </div>
                  ))}
              </div>
            </>
          )}
          {tabValue === 1 && (
            <>
              <div className='row pt-4'>
                <div className='row pt-4'>
                  <MediaViewer
                    images={selectedCategory?.images || []}
                    videos={(() => {
                      const { Video: videoMediaContent } = decodeMediaKeyValue(
                        selectedCategory?.mediaContent,
                      );
                      return videoMediaContent || selectedCategory?.videos || {};
                    })()}
                    gifs={(() => {
                      const { GIF: gifMediaContent } = decodeMediaKeyValue(
                        selectedCategory?.mediaContent,
                      );
                      return gifMediaContent || selectedCategory?.gifs || {};
                    })()}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      {selectedCategory && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={SPA_CATEGORY_TAB_LIST}
          onViewToggle={onViewToggle}
          title={selectedCategory?.name}
          createdUserId={selectedCategory?.createdBy}
          isEditable={permissions[RBAC_TYPE_HOTEL_SPA] === RBAC_PERMISSION_LEVEL_FULL_ACCESS}
          tabClass='col-5'
        />
      )}
    </>
  );
};

export default CategoryView;
